import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SetupInterview from "./SetupInterview";
import SetupQuestions from "./SetupQuestions";
import Layout from "../components/Layout";

export default function InterviewSetupWizard() {
  const { interviewId } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const nextStep = () => setStep((prev) => Math.min(prev + 1, 3));
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));

  const finishSetup = () => {
    // Redirect to Interview Details or Dashboard
    navigate(`/interviews/${interviewId}`);
  };

  return (
    <Layout>
      <div className="mb-6">
        <h2 className="text-2xl font-bold">Setup Interview Wizard</h2>
        <div className="flex items-center mt-4">
          <StepIndicator step={step} currentStep={1} label="Interview Info" />
          <StepIndicator step={step} currentStep={2} label="Questions" />
          <StepIndicator step={step} currentStep={3} label="Review & Finish" />
        </div>
      </div>

      <div className="mt-6">
        {step === 1 && <SetupInterview interviewId={interviewId} onNext={nextStep} />}
        {step === 2 && <SetupQuestions interviewId={interviewId} />}
        {step === 3 && (
          <div>
            <h3 className="text-xl font-semibold mb-4">Review & Finish</h3>
            <p>All steps completed. Ready to publish this interview.</p>
            <button
              onClick={finishSetup}
              className="mt-4 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            >
              Finish Setup
            </button>
          </div>
        )}
      </div>

      <div className="flex justify-between mt-6">
        {step > 1 ? (
          <button
            onClick={prevStep}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Back
          </button>
        ) : (
          <div />
        )}
        {step < 3 && (
          <button
            onClick={nextStep}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Next
          </button>
        )}
      </div>
    </Layout>
  );
}

function StepIndicator({ step, currentStep, label }) {
  const isActive = step === currentStep;
  const isCompleted = step > currentStep;
  return (
    <div className={`flex-1 text-center ${isActive ? "font-bold" : ""}`}>
      <div
        className={`w-8 h-8 mx-auto mb-2 rounded-full flex items-center justify-center ${
          isCompleted ? "bg-green-500 text-white" : isActive ? "bg-blue-500 text-white" : "bg-gray-300"
        }`}
      >
        {currentStep}
      </div>
      <span>{label}</span>
    </div>
  );
}